import { SR_VOICE_DEFAULT_MIME } from "../sr-constants";

export const pickVoiceMime = (): string => {
    if (typeof MediaRecorder === "undefined") return SR_VOICE_DEFAULT_MIME;
    if (MediaRecorder.isTypeSupported(SR_VOICE_DEFAULT_MIME)) {
        return SR_VOICE_DEFAULT_MIME;
    }
    if (MediaRecorder.isTypeSupported("audio/webm;codecs=opus")) {
        return "audio/webm;codecs=opus";
    }
    return "";
};

export const stopMediaTracks = (stream: MediaStream | null) => {
    stream?.getTracks().forEach((t) => t.stop());
};
